import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AnnouncementTourState } from "./types";

const initialState: AnnouncementTourState = {
  seenCampaigns: [],
};

export const announcementTourSlice = createSlice({
  name: "announcementTour",
  initialState,
  reducers: {
    /**
     * Idempotent on purpose. This fires from a modal's onClose, and React 18 StrictMode double-invokes
     * effects in development — without the guard the same id lands in the list twice.
     */
    markCampaignSeen: (state, action: PayloadAction<string>) => {
      if (state.seenCampaigns.includes(action.payload)) return;

      state.seenCampaigns.push(action.payload);
    },
  },
});

export default announcementTourSlice.reducer;
export const { markCampaignSeen } = announcementTourSlice.actions;
